/** Safe teardown for jQuery plugins used with React. */

export function reparentCarouselSlides(element) {
  if (!element) return;

  element.querySelectorAll('.slick-cloned, .owl-item.cloned').forEach((node) => {
    node.remove();
  });

  const wrappers = element.querySelectorAll(
    '.slick-list, .slick-track, .owl-stage-outer, .owl-stage',
  );
  wrappers.forEach((wrapper) => {
    while (wrapper.firstChild) {
      element.appendChild(wrapper.firstChild);
    }
    wrapper.remove();
  });

  element
    .querySelectorAll('.slick-arrow, .slick-dots, .owl-nav, .owl-dots')
    .forEach((node) => {
      if (node.parentElement === element) {
        node.remove();
      }
    });
}

export function destroyOwlCarousel(element) {
  const $ = window.jQuery;
  if (!element) return;

  if ($?.fn?.owlCarousel) {
    const $el = $(element);
    if ($el.length && $el.hasClass('owl-loaded')) {
      try {
        $el.trigger('destroy.owl.carousel');
      } catch {
        /* already destroyed */
      }
    }
    $el.removeClass('owl-loaded owl-drag owl-hidden owl-grab');
  }

  reparentCarouselSlides(element);
}

export function destroySlickCarousel(element) {
  const $ = window.jQuery;
  if (!element) return;

  if ($?.fn?.slick) {
    const $el = $(element);
    if ($el.length && $el.hasClass('slick-initialized')) {
      try {
        $el.slick('unslick');
      } catch {
        /* already destroyed */
      }
    }
  }

  reparentCarouselSlides(element);
}

export function initLinkedSlickWhenReady(
  forElement,
  navElement,
  forOptions,
  navOptions,
  maxAttempts = 50,
) {
  let attempts = 0;
  let cancelled = false;

  const timer = setInterval(() => {
    if (cancelled) {
      clearInterval(timer);
      return;
    }

    attempts += 1;
    const $ = window.jQuery;

    if (!forElement || !navElement) {
      if (attempts >= maxAttempts) clearInterval(timer);
      return;
    }

    const $for = $(forElement);
    const $nav = $(navElement);

    if ($for.hasClass('slick-initialized') && $nav.hasClass('slick-initialized')) {
      clearInterval(timer);
      return;
    }

    if (!$?.fn?.slick) {
      if (attempts >= maxAttempts) clearInterval(timer);
      return;
    }

    destroySlickCarousel(forElement);
    destroySlickCarousel(navElement);

    $for.slick({ ...forOptions, asNavFor: $nav });
    $nav.slick({ ...navOptions, asNavFor: $for });
    clearInterval(timer);
  }, 100);

  return () => {
    cancelled = true;
    clearInterval(timer);
    destroySlickCarousel(forElement);
    destroySlickCarousel(navElement);
  };
}

export function initOwlWhenReady(element, options, maxAttempts = 50) {
  let attempts = 0;
  let cancelled = false;

  const timer = setInterval(() => {
    if (cancelled) {
      clearInterval(timer);
      return;
    }

    attempts += 1;
    const $ = window.jQuery;

    if (!element) {
      if (attempts >= maxAttempts) clearInterval(timer);
      return;
    }

    const $carousel = $(element);

    if ($carousel.hasClass('owl-loaded')) {
      clearInterval(timer);
      return;
    }

    if (!$?.fn?.owlCarousel) {
      if (attempts >= maxAttempts) clearInterval(timer);
      return;
    }

    destroyOwlCarousel(element);
    $carousel.owlCarousel(options);
    clearInterval(timer);
  }, 100);

  return () => {
    cancelled = true;
    clearInterval(timer);
    destroyOwlCarousel(element);
  };
}

export function initSlickWhenReady(element, options, maxAttempts = 50) {
  let attempts = 0;
  let cancelled = false;

  const timer = setInterval(() => {
    if (cancelled) {
      clearInterval(timer);
      return;
    }

    attempts += 1;
    const $ = window.jQuery;

    if (!element) {
      if (attempts >= maxAttempts) clearInterval(timer);
      return;
    }

    const $slide = $(element);

    if ($slide.hasClass('slick-initialized')) {
      clearInterval(timer);
      return;
    }

    if (!$?.fn?.slick) {
      if (attempts >= maxAttempts) clearInterval(timer);
      return;
    }

    destroySlickCarousel(element);
    $slide.slick(options);
    clearInterval(timer);
  }, 100);

  return () => {
    cancelled = true;
    clearInterval(timer);
    destroySlickCarousel(element);
  };
}

const CAROUSEL_SELECTORS = [
  '.slick-initialized',
  '.owl-loaded',
  '.project-slide-1',
  '.partner-logos-slider',
  '.testi-slide-1',
  '.team-slider-for',
  '.team-slider-nav',
  '.rs-carousel.owl-carousel',
].join(',');

export function destroyAllReactCarousels() {
  const root = document.getElementById('root');
  if (!root) return;

  root.querySelectorAll(CAROUSEL_SELECTORS).forEach((el) => {
    destroySlickCarousel(el);
    destroyOwlCarousel(el);
  });
}
